<template>
	<TopNavFooter>
  <div class="main-content" id="admin" style="">
  <spinner :spinnerOn="loading"></spinner>

    <div class="container-fluid" style="background: #fff;padding: 30px;padding-top:35px;">
	
	<span style="font-size:35px; font-weight:bold;">Email Scheduler Logs</span>
	<div style="padding-top:20px;">
	<label style="width: 50%;">Enter the email id to search:
	<input type="text" v-model="searchTerm" class="form-control" placeholder="Minimum 5 characters"/>
	</label>
	<button class="btn btn-primary get-logs" v-bind:class="{'disabled': searchTerm.trim().length<5}" @click="getLogs()">Get Logs</button>
	</div>
	<table class="table table-hover">
    <thead>
      <tr>
        <th>Email Id</th>
        <th>Brand</th>
        <th>Email Type</th>
        <th>Log Description</th>
        <th>Date-Time</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="i in logsArr">
        <td>{{i.emailId}}</td>
        <td>{{i.brand}}</td>
        <td>{{i.action}}</td>
        <td>{{i.statusCode}}</td>
        <td>{{i.actionDate}}</td>
      </tr>
    </tbody>
  </table>
  <div v-if="logsArr.length === 0 && !emptyLogs">Kindly enter the email id and search.</div>
  <div v-if="emptyLogs">No logs found. </div>
	  </div>
    </div>  <!-- END: container -->
</TopNavFooter>
</template>
<script>
  import TopNavFooter from "@/components/widgets/TopNavFooter"
  import idmApi from '@/idm-api'
  import Spinner from '@/components/Spinner';
  import { locale } from '@/i18n/locale.js'
  import { EventBus } from '@/event-bus.js';
  import storage from '@/helpers/storage';
  // import Vue from 'vue';
  const apiUrl = process.env.API_URL;
  // const onecargillappid = process.env.KEY_ID;
  // const brandDetails = require('../brand-details.json');
  let environment = process.env.NODE_ENV;
  let brandDetails = "";
  console.log('env=====', environment);
  if (environment === 'production') {
    brandDetails = require('../brand-details.json');
  } else if (environment === 'stage') {
    brandDetails = require('../brand-details-stage.json');
  } else {
    brandDetails = require('../brand-details-dev.json');
  }
  export default {
    name: 'tm',
    components: {
      TopNavFooter,
      Spinner
    },
    created() {
      // this.changeCustomer();
      var self = this;
      self.userId = storage.get('cf-user').sub
      self.email = storage.get('email')
      this.user_lang = this.lang_br
      setTimeout(self.assignUserLang(), 1000) // lang_br for br portuguese
      EventBus.$on('lang', function (language) {
        self.user_lang = self.lang_obj[language]
      })
    },
    mounted () {
      // var self = this
    },
    watch: {
    },
    methods: {
      assignUserLang() {
        var self = this
        self.user_lang = self.lang_obj[this.lang]
      },
      getLogs() {
        var self = this
        self.loading = true
        idmApi.getLogs(`${apiUrl}/auth/userlogs/${self.searchTerm}`).then(function (response) {
          self.emptyLogs = false
          self.logsArr = response.data.reverse()
          self.loading = false
        }).catch(error => {
          console.log(error)
          if (error.response.status === 404) {
            self.logsArr = []
            self.emptyLogs = true
          } else {
            window.alert(error)
          }
          self.loading = false
        })
      }
    },
    data() {
      return {
        brandDetails: brandDetails,
        lang: locale.lang,
        lang_obj: locale.lang_obj,
        userId: '',
        loading: false,
        user_lang: {},
        prefLang: 'en_US',
        searchTerm: '',
        logsArr: [],
        emptyLogs: false
      }
    },
    computed: {
    }
  }
</script>
<style scoped>
button {background:var(--theme-primary) !important}
button { height: 32px !important; color: #fff !important}
.get-logs{
padding: 8px 15px;
    height: 36px !important;
    margin-top: -2px;
	}
th, td{
    padding: 5px 5px !important;
	font-size:14px !important;
}
</style>



// WEBPACK FOOTER //
// SystemLogs.vue?0849515d